import { OilChangeCalculations } from '@appTypes/oilChangeCalculationTypes';

type OilChange = NonNullable<OilChangeCalculations['oilChange']>;

const kroner = (amount: number | string) => `kr ${amount},-`;

// Membership is only mentioned when it actually saves money: one line if not, two if so.
export const oilChangePriceLines = (oilChange: OilChange | undefined, isMember: boolean): string[] => {
  const memberPrice = oilChange?.totalPriceForMembers ?? 0;
  const nonMemberPrice = oilChange?.totalPriceForNonMembers ?? 0;

  if (memberPrice >= nonMemberPrice) {
    return [`Pris for oljeskift: ${kroner(nonMemberPrice)}`];
  }

  // The member price is the one that comes back with ore attached.
  const rounded = memberPrice.toFixed(0);

  return [
    isMember ? `Din pris: ${kroner(rounded)}` : `Pris for medlemmer: ${kroner(rounded)}`,
    `Pris for ikke-medlemmer: ${kroner(nonMemberPrice)}`,
  ];
};
